import { render, staticRenderFns } from "./SparePartShop.vue?vue&type=template&id=1b385b08&scoped=true&"
import script from "./SparePartShop.ts?vue&type=script&lang=ts&"
export * from "./SparePartShop.ts?vue&type=script&lang=ts&"
import style0 from "./SparePartShop.vue?vue&type=style&index=0&id=1b385b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b385b08",
  null
  
)

export default component.exports